import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
@Component({
    selector: 'save-buyer-paid-transfer-fees-modal',
    styleUrls: ['./save-buyer-paid-transfer-fees-modal.component.scss'],
    template: `
        <div class="save-buyer-paid-transfer-fees-modal">
            <div class="bottom-margin">
                <p class="body">
                    The fee settings for this supplier will be updated to the following:
                </p>
            </div>
            <data-card class="bottom-margin mb-2">
                <div class="data-item">
                    <div class=" p label">
                        Buyer Paid Delivery Fees
                    </div>
                    <div class="p body text-dark-gray">{{ paidTransfer }}</div>
                </div>
            </data-card>
        </div>
    `
})
export class SaveBuyerPaidTransferFeesModalComponent {
    public paidTransfer: string;

    constructor(private _modalService: ModalService) {
        const modalData = this._modalService.modal.data;

        this.paidTransfer = modalData.paidTransfer;
    }
}
